export default "__VITE_ASSET__Bm61hrLa__"